var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-button',_vm._b({attrs:{"isFluid":true,"size":_vm.getButtonSize},on:{"click":function($event){return _vm.performAction($event)}}},'common-button',_vm.referralButtonProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }